module.exports = __webpack_public_path__ + "img/vertical_4_2_3.3ea1bf63.png";